import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { withTranslation } from 'react-i18next';
import '../../assets/css/user-help.css';
var ShortCut = /*#__PURE__*/function (_React$Component) {
  _inherits(ShortCut, _React$Component);
  var _super = _createSuper(ShortCut);
  function ShortCut(props) {
    var _this;
    _classCallCheck(this, ShortCut);
    _this = _super.call(this, props);
    // get platform of browser
    _this.platfrom = navigator.platform.indexOf('Win') < 0 ? 'Mac' : 'Win';
    return _this;
  }
  _createClass(ShortCut, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("li", {
        className: 'help-shortcut'
      }, /*#__PURE__*/React.createElement("div", {
        className: 'help-shortcut-left'
      }, this.props.shortcutName), /*#__PURE__*/React.createElement("div", {
        className: 'help-shortcut-right'
      }, /*#__PURE__*/React.createElement(ShortCutRight, {
        platfrom: this.platform,
        shortcuts: this.props.shortcuts
      })));
    }
  }]);
  return ShortCut;
}(React.Component);
var ShortCutRight = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ShortCutRight, _React$PureComponent);
  var _super2 = _createSuper(ShortCutRight);
  function ShortCutRight() {
    _classCallCheck(this, ShortCutRight);
    return _super2.apply(this, arguments);
  }
  _createClass(ShortCutRight, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.props.shortcuts.map(function (shortcut) {
        var shortcutFirKey = shortcut[0];
        var shortcutSecnKey = shortcut[1];
        if (typeof shortcut[0] === 'object') {
          if (_this2.platfrom === 'Win') {
            shortcutFirKey = shortcut[0][0];
          } else {
            shortcutFirKey = shortcut[0][1];
          }
        }
        return /*#__PURE__*/React.createElement("div", {
          className: 'help-shortcut-right-container',
          key: 'help' + shortcut[0]
        }, shortcutFirKey ? /*#__PURE__*/React.createElement("div", {
          className: 'key shortcut-first'
        }, shortcutFirKey) : null, shortcutSecnKey ? /*#__PURE__*/React.createElement("div", {
          className: 'key shortcut-second'
        }, shortcutSecnKey) : null);
      }));
    }
  }]);
  return ShortCutRight;
}(React.PureComponent);
var HelpShortcutList = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits(HelpShortcutList, _React$PureComponent2);
  var _super3 = _createSuper(HelpShortcutList);
  function HelpShortcutList(props) {
    var _this3;
    _classCallCheck(this, HelpShortcutList);
    _this3 = _super3.call(this, props);
    _this3.shortcutData = [{
      'Make_list': [['*/-', 'space']],
      'Make_ordered_list': [['1.', 'space']],
      'Insert_new_item': [['Enter']],
      'Insert_child_in_item': [['Shift', 'Enter']],
      'Increase_depth': [['Tab']]
    }, {
      'Heading_1': [['#', 'space']],
      'Heading_2': [['##', 'space']],
      'Heading_3': [['###', 'space']],
      'Heading_4': [['####', 'space']],
      'Heading_5': [['#####', 'space']],
      'Heading_6': [['######', 'space']]
    }, {
      'Make_code_block': [['```']],
      'Insert_new_line': [['Enter']],
      'Escape_code_block': [[['Ctrl', 'Cmd'], 'Enter']],
      'Insert_indent': [['Tab']]
    }, {
      'Make_Block_quote': [['>', 'space']],
      'Escape_Block_quote': [['Enter']]
    }, {
      'Insert_Table_Row': [['Enter']],
      'Escape_table': [[['Ctrl', 'Cmd'], 'Enter']]
    }, {
      'Insert_Formula': [[['Ctrl', 'Cmd'], '$']]
    }, {
      'Bold': [['**bold** / __bold__', 'space']],
      'Italic': [['*italic* / _italic_', 'space']],
      'Italic_Bold': [['***italic*** / ___italic___', 'space']],
      'Inline_code': [['`code`', 'space']]
    }, {
      'Save_file': [[['Ctrl', 'Cmd'], 's']]
    }, {
      'Paste_screen_shot': [[['Ctrl', 'Cmd'], 'v']],
      'Drag_image_from_anywhere_to_upload_it': []
    }];
    return _this3;
  }
  _createClass(HelpShortcutList, [{
    key: "render",
    value: function render() {
      var title = this.props.data.shortcutType;
      var dataList = this.props.data.shortcutData;
      var liArr = [];
      for (var prop in dataList) {
        var shortcutKeyArr = this.shortcutData[this.props.index][prop];
        liArr.push( /*#__PURE__*/React.createElement(ShortCut, {
          key: 'help ' + prop,
          shortcutName: dataList[prop],
          shortcuts: shortcutKeyArr
        }));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: 'help-content-container'
      }, /*#__PURE__*/React.createElement("h5", {
        className: 'help-shortcut-type'
      }, title), /*#__PURE__*/React.createElement("ul", {
        className: 'help-shortcut-list'
      }, liArr));
    }
  }]);
  return HelpShortcutList;
}(React.PureComponent);
var UserHelp = /*#__PURE__*/function (_React$PureComponent3) {
  _inherits(UserHelp, _React$PureComponent3);
  var _super4 = _createSuper(UserHelp);
  function UserHelp() {
    _classCallCheck(this, UserHelp);
    return _super4.apply(this, arguments);
  }
  _createClass(UserHelp, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      var userHelp = t('userHelp', {
        returnObjects: true
      });
      return /*#__PURE__*/React.createElement("div", {
        className: 'seafile-editor-help align-self-end'
      }, /*#__PURE__*/React.createElement("div", {
        className: 'help-header d-flex'
      }, /*#__PURE__*/React.createElement("div", {
        className: 'help-title'
      }, userHelp.title), /*#__PURE__*/React.createElement("div", {
        className: 'help-close',
        onClick: this.props.hideHelpDialog
      }, /*#__PURE__*/React.createElement("i", {
        className: 'iconfont icon-times-circle'
      }))), /*#__PURE__*/React.createElement("div", {
        className: 'help-content'
      }, userHelp.userHelpData.map(function (item, index) {
        return /*#__PURE__*/React.createElement(HelpShortcutList, {
          key: 'help-list' + index,
          index: index,
          data: item
        });
      })));
    }
  }]);
  return UserHelp;
}(React.PureComponent);
export default withTranslation('seafile-editor')(UserHelp);